import Flickity from "flickity";

const initCarousel = (carouselEls) => {
    carouselEls.forEach((carousel) => {
        const carouselPrev = carousel.querySelector(".js-carousel-prev");
        const carouselNext = carousel.querySelector(".js-carousel-next");

        const flickityOptions = {
            cellAlign: "left",
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            setGallerySize: true,
            cellSelector: ".js-slide",
            adaptiveHeight: true
        };

        const flkty = new Flickity(carousel, flickityOptions);

        if (carouselPrev) {
            carouselPrev.addEventListener("click", () => {
                flkty.previous();
            });
        }

        if (carouselNext) {
            carouselNext.addEventListener("click", () => {
                flkty.next();
            });
        }
    });
};

export { initCarousel as default };
